/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import React, { TextareaHTMLAttributes } from 'react';
import styled from 'styled-components';
import { Property } from 'csstype';

export const TextArea: React.FC<TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => <textarea className="form-textarea" {...props} />;

export const FlexRow = styled.div<{ $gap?: Property.Gap; $justifyContent?: Property.JustifyContent; $alignItems?: Property.AlignItems }>`
    display: flex;
    align-items: ${({ $alignItems }) => $alignItems};
    gap: ${({ $gap }) => $gap || '1em'};
    justify-content: ${({ $justifyContent }) => $justifyContent};
`;

export const FlexColumn = styled.div<{ gap?: Property.Gap }>`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap || '1em'};
`;
